import React from 'react';
import { useSelector } from 'react-redux';

import RenderSectorTable from 'forms/RenderSectorTable';
import { selectSectorEntityTypeId } from 'components/PersonForm/selectors';

export default function EntityTableFieldRender(): React.ReactElement | null {
    const entityTypeId = useSelector(selectSectorEntityTypeId) as number;

    return <RenderSectorTable entityTypeId={entityTypeId} />;
}
